import request from '@/utils/request'

export function create(data) {
  return request({
    url: '/admin/campaign',
    method: 'post',
    data
  })
}

export function getAll() {
  return request({
   url: '/admin/campaign',
   method: 'get',
   })
}

export function get(id) {
  return request({
   url: '/admin/campaign/'+id,
   method: 'get',
   })
}

export function togglePause(id) {
  return request({
   url: '/admin/campaign/'+id+'/toggle-pause',
   method: 'post',
   })
}

export function retry(id, payload) {
  return request({
   url: '/admin/campaign/'+id+'/retry',
   method: 'post',
   payload
  })
}

export function previewMessage(id, message_id) {
  return request({
   url: '/admin/campaign/'+id+'/message/'+message_id+'/preview',
   method: 'get',
  })
}

export function unsubscribe(payload) {
  return request({
    url: '/user/campaign/unsubscribe',
    method: 'post',
    data: payload
  });
}